module.exports = "/virtual-football-league/img/amblems/left/logos/WestHamUtd.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/WestHamUtd.png
// module id = 2132
// module chunks = 4